import { Model } from "@vuex-orm/core"
import Student from "@/models/Student"
import { notify } from "@/services/notification"

export default class Assistant extends Model {
  static get entity() {
    return "assistants"
  }

  static fields() {
    return {
      id: this.attr(null),
      society: this.attr(""),
      name: this.attr(""),
      email: this.attr(""),
      mobile: this.attr(""),
      mobile2: this.attr(""),
      address: this.attr(""),
      comment: this.attr(""),
      mandat: this.attr(""),
      students: this.hasMany(Student, "student_id"),
    }
  }

  static get() {
    return this.api().get("/social_assistances", { dataKey: "data" })
  }

  static deleteOne(id) {
    return this.api()
      .delete("/social_assistances/" + id, {
        delete: id,
      })
      .then(() => {
        notify("success", "Supprimé")
      })
      .catch((error) => {
        notify("error", error.response.data)
      })
  }

  static async put(assistant) {
    return this.api().put(`/social_assistances/`, assistant, {
      dataKey: "data",
    })
  }

  static async post(assistant) {
    return this.api()
      .post(`/social_assistances/`, assistant, {
        dataKey: "data",
      })
      .then(() => {
        notify("success", "Ajouté")
      })
      .catch((error) => {
        notify("error", error.response.data)
        return error
      })
  }
}
